import React from 'react';
import BtnPreviousPath from '../components/btn-previous-path';
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export default function NotFound() {

    return (
        <main style={{ padding: "1rem 0", overflow: "auto" }}>
            <div className="container-fluid" style={{ float: "left", minHeight: "46px" }}>

                <h2 style={{ textAlign: "center", margin: "30px" }}>La pagina che cerchi non esiste!</h2>

                <div className="row">
                    <div className="col-12 col-md-12 col-lg-6 col-xl-6" style={{ textAlign: "center" }}>
                        <BtnPreviousPath></BtnPreviousPath>
                    </div>
                    <div className="col-12 col-md-12 col-lg-6 col-xl-6" style={{ textAlign: "center" }}>
                        <button type="button" className="btn btn-primary" style={{ width: "12rem" }}>
                            <Link to="/login">
                                <FontAwesomeIcon icon={['fas', 'user']} size={'2x'} color={'white'} />
                                <span style={{ margin: "8px", verticalAlign: "super" }}>Vai a Login (esci)</span>
                            </Link>
                        </button>
                    </div>
                </div>
            </div>

        </main>
    )

}